import { SternumTheme, TabTheme } from '@sternum/ui';

import { Colors } from '../constants';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function SBOMLightTabsTheme(theme: SternumTheme): Partial<TabTheme.TabTheme> {
  return {
    textColor: Colors.GreyDarkest,
    hoverTextColor: Colors.BrandBlueMiddle,
    activeBorderColor: Colors.BrandBlueMiddle,
    activeTextColor: Colors.DarkerText,

    counterBorderRadius: '4px',
    counterTextColor: Colors.GreyDarkest,
    counterBackgroundColor: Colors.Light,
    activeCounterTextColor: Colors.BrandBlue,
    activeCounterBackgroundColor: Colors.BrandBlueLightest,
    hoverCounterTextColor: Colors.BrandBlueMiddle,
    hoverCounterBackgroundColor: Colors.BrandBlueLightest,
    counterBorder: 'none',
    activeCounterBorder: 'none',
    hoverCounterBorder: 'none',
    fontSize: '12px',
    lineHeight: '18px',
  };
}
